module.exports = __webpack_public_path__ + "static/media/13.0856f58d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/13.svg
// module id = 125
// module chunks = 0